import axios from 'axios'
import { messaging, getToken, onMessage } from './firebase'

export const requestNotificationPermission = async () => {
  try {
    const currentToken = await getToken(messaging, {
      vapidKey:
        'BCTuSIO9pZm7Gf5PvxGQzCnVuwYEfYVkF1y6csByAnv1vtdLoDABT6Etc4kMLE8EK_nhGMDYuGkPG_HTkBnHlW4',
    })
    if (currentToken) {
      try {
        const payload = {
          metaData: undefined,
          fcmToken: currentToken,
          deviceType: 'WEB',
        }

        await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}${process.env.REACT_APP_API_PREFIX}/app/provider/set-fcm`,
          payload,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          },
        )
      } catch (error) {
        console.log('API error >>', error)
      }
    } else {
      console.log('No registration token available.')
    }
  } catch (error) {
    console.error('An error occurred while retrieving token.', error)
  }
}

export const setupMessageListener = () => {
  onMessage(messaging, (payload) => {
    console.log('Message received. ', payload)
  })
}
